import * as util from './util'

export const StorageValueType = {
  TEXT: 'text',
  JSON: 'json'
}

const localStorage = window.localStorage;
const nowTime = new Date().getTime();

export const Storage = (function () {

  function Storage() { }

  Storage.prototype.set = function (key, value) {
    if (!key) {
      throw new Error('set storage : empty key');
    }
    if (!util.isEmpty(value)) {
      value = JSON.stringify(value);
      localStorage.setItem(key, value);
    }
    return this;
  }

  Storage.prototype.get = function (key, valueType) {
    valueType = valueType || StorageValueType.JSON;
    if (key) {
      var value = localStorage.getItem(key);
      if (valueType == StorageValueType.JSON) {
        try {
          return JSON.parse(value);
        } catch (e) {
          return value;
        }
      } else if (valueType == StorageValueType.TEXT) {
        return value;
      }
    }
    return '';
  }

  Storage.prototype.has = function (key) {
    return Object.prototype.hasOwnProperty.call(localStorage, key);
  }

  Storage.prototype.remove = function (key) {
    if (this.has(key)) {
      localStorage.removeItem(key);
    }
    return this;
  }

  Storage.prototype.keys = function () {
    var keys = new Array();
    for (var key in localStorage) {
      if (this.has(key)) {
        keys.push(key);
      }
    }
    return keys;
  }

  Storage.prototype.size = function () {
    return this.keys().length;
  }

  return new Storage();
}());


// WEBPACK FOOTER //
// ./src/util/storage.js